import http from "../http-common";
import httpDownload from "../http-download";

class ParentService {
    getNotifyParent(pageNumber, maxPageItem, dataSearch) {
        return http.get(`/parent/notify?pageNumber=${pageNumber}&maxPageItem=${maxPageItem}&title=${dataSearch.title}&content=${dataSearch.content}&dateList=${dataSearch.dateList}`);
    }

    viewNotifyParent(idList) {
        return http.put(`/parent/notify?idList=${idList}`);
    }

    downloadFileNotify(id) {
        return httpDownload.get(`parent/notify/download/${id}`);
    }

    searchNotifySchoolParent(pageNumber, maxPageItem, active, dateList, title, content) {
        return http.get(`/parent/news?pageNumber=${pageNumber}&maxPageItem=${maxPageItem}&active=${active}&dateList=${dateList}&title=${title}&content=${content}`);
    }

    downloadFileNews(id) {
        return httpDownload.get(`parent/news/download/${id}`);
    }

    getVideoParentService() {
        return http.get(`parent/video`);
    }

    getVideoOtherParentService() {
        return http.get(`parent/video/other`);
    }

    chartdAttendanceParent() {
        return http.get(`parent/dashboard/chart/attendance`);
    }

    chartFeesParent() {
        return http.get(`parent/dashboard/chart/fees`);
    }

    schoolInforParent() {
        return http.get(`parent/dashboard/infor`);
    }

    getChangeKidsParent() {
        return http.get(`parent/dashboard/changeKids`);
    }

    updateChangeKidsParent(idKid) {
        return http.put(`parent/dashboard/changeKids/${idKid}`);
    }

    /**
     * Api filter phụ huynh
     *
     * @param {number} page - số trang
     * @param {number} limit - số dữ liệu hiển thị trong 1 trang
     * @param {string} status - trạng thái của học sinh
     * @param {number} idGrade - id của khối trong trường
     * @param {number} idClass - id của lớp trong trường
     * @param {string} nameOrPhone - tên hoặc số điện thoại
     * */
    filterParent(page, limit, status, idGrade, idClass, nameOrPhone) {
        return http.get(`student/transfer/searchChildrenOfParent?idGrade=${idGrade}&idClass=${idClass}&status=${status}&nameOrPhone=${nameOrPhone}&pageNumber=${page}&maxPageItem=${limit}`);
    }

    getDataExportExcel() {
        return http.get(`student/transfer/searchChildrenOfParent-noPaging?idGrade=&idClass=&status=&nameOrPhone=&pageNumber=1&maxPageItem=30`)
    }

}

export default new ParentService();